import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase env vars. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in propelion_admin/.env');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const getSupabaseUrl = () => supabaseUrl;
